<template>
  <div class="element-based-generate">
    <EbIcons />

    <!-- 生成中：AI 要素确认流程（聊天中生成文书后卡片可跳文书页） -->
    <GenerateFlow
      v-if="phase === 'flow'"
      :input="flowPayload"
      @back="goHome"
      @view-doc="openDoc"
    />
    <!-- 生成结果：文书预览 + AI 修改对话 -->
    <GenerateResult
      v-else-if="phase === 'result'"
      :materials="flowPayload.materials"
      :record="resultRecord"
      @back="viewRecordId ? (phase = 'record') : goHome()"
    />
    <!-- 聊天记录：列表「查看」进入，与生成流程同款聊天界面，可继续对话；
         文书卡片在聊天框上方，可查看 / 下载 -->
    <GenerateFlow
      v-else
      :input="flowPayload"
      :record-id="viewRecordId"
      :chat-id="viewChatId"
      :title="viewName"
      @back="goHome"
      @view-doc="openDoc"
    />
  </div>
</template>

<script setup>
defineOptions({ name: "ElementBasedGenerateResults" });
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import EbIcons from "./components/EbIcons.vue";
import GenerateFlow from "./components/GenerateFlow.vue";
import GenerateResult from "./components/GenerateResult.vue";
import { flowInput, elementConversationId } from "./store";
import { EXAMPLE_CASE } from "@/api/elementBased";

const router = useRouter();
const route = useRoute();

// 「查看」进入（view=chat）：id 为记录 id（Detail / 下载用），
// chatId 为 aiChatsId（聊天页查历史 / 续聊用）
const isRecordView = route.query.view === "chat";
const viewRecordId =
  isRecordView && route.query.id ? String(route.query.id) : null;
const viewChatId =
  isRecordView && route.query.chatId ? String(route.query.chatId) : "";
const viewName = route.query.name ? String(route.query.name) : "";

// 文书页入参（记录模式）：记录查看时用记录 id/名称；
// 聊天中生成文书后点「查看文书」时，用子组件随事件带回的文书 id
const resultRecord = ref(
  viewRecordId ? { id: viewRecordId, name: viewName } : null,
);
const openDoc = (id) => {
  if (id) resultRecord.value = { id: String(id), name: viewName || "" };
  phase.value = "result";
};

// 会话 id 随路由 query 带入（开始生成流程）；刷新后页面快照会丢，路由参数是可靠来源
if (!isRecordView && route.query.id)
  elementConversationId.value = String(route.query.id);

// 首页开始生成时写入的快照；直接访问 / 刷新导致快照丢失时回落示例案例
// （与原型行为一致，保证流程可演示）
const flowPayload = flowInput.value
  ? { ...flowInput.value }
  : { text: EXAMPLE_CASE, files: [], sourceType: "text" };

// flow：AI 要素确认（生成中）；result：结果页；record：聊天记录页（可续聊）。
// 带 view=chat 进入（列表「查看」）直接落在聊天记录页
const phase = ref(viewRecordId ? "record" : "flow");

const goHome = () => router.push("/home/ElementBased");
</script>

<style scoped>
.element-based-generate {
  width: 100%;
  margin-top: 24px;
}
</style>
